/**
 * LPS Geo Suggestion – Theme-level fallback when Shopify automatic redirect doesn’t run.
 * Uses Shopify’s browsing_context_suggestions.json to detect country and show a
 * “It looks like you’re in [region]” popup with option to switch store (subdomain).
 * Respects cookie so we don’t show again for 14 days after dismiss or switch.
 */
(function () {
  var COOKIE_NAME = 'lps_geo_dismissed';
  var COOKIE_DAYS = 14;

  /** European/EEA country codes that map to the Europe store (eu. subdomain) */
  var EU_COUNTRY_CODES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT',
    'NL','PL','PT','RO','SK','SI','ES','SE','GB','UK','NO','IS','CH','LI','MC','AD','SM','VA'
  ];

  function getCurrentRegion() {
    var host = typeof location !== 'undefined' ? location.hostname : '';
    if (host.indexOf('eu.') === 0) return 'eu';
    if (host.indexOf('ca.') === 0) return 'ca';
    return 'us';
  }

  function countryToRegion(countryHandle) {
    if (!countryHandle) return null;
    var code = countryHandle.toUpperCase();
    if (code === 'US') return 'us';
    if (code === 'CA') return 'ca';
    if (EU_COUNTRY_CODES.indexOf(code) !== -1) return 'eu';
    return null;
  }

  function regionLabel(region) {
    if (region === 'eu') return 'Europe';
    if (region === 'ca') return 'Canada';
    return 'United States';
  }

  function getCookie(name) {
    var match = typeof document !== 'undefined' && document.cookie
      ? document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      : null;
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    if (typeof document === 'undefined') return;
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + (value || '') + ';path=/;max-age=' + (days * 24 * 60 * 60) + ';SameSite=Lax';
  }

  function buildRedirectUrl(region) {
    var host = location.hostname;
    var path = location.pathname || '/';
    if (host.charAt(2) === '.') host = host.slice(3);
    path = path.replace(/^\/en-ca\//, '/');
    if (region === 'us') return location.origin.replace(location.hostname, host) + path;
    return 'https://' + region + '.' + host + path;
  }

  function showPopup(suggestedRegion, suggestedCountryName) {
    var currentRegion = getCurrentRegion();
    if (suggestedRegion === currentRegion) return;

    var label = regionLabel(suggestedRegion);
    var message = "It looks like you're in " + (suggestedCountryName || label) + ". Switch to the " + label + " store for local pricing and shipping?";

    var overlay = document.createElement('div');
    overlay.className = 'lps-geo-suggestion-overlay';

    var banner = document.createElement('div');
    banner.className = 'geoip-popup-banner lps-geo-suggestion-banner';
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-label', 'Region suggestion');
    banner.innerHTML =
      '<div class="geoip-text-block geoip-text-block--lps">' +
        '<p class="geoip-message">' + message + '</p>' +
        '<div class="geoip-button-block">' +
          '<button type="button" class="lps-geo-switch">Switch to ' + label + '</button>' +
          '<button type="button" class="lps-geo-stay">Stay here</button>' +
        '</div>' +
      '</div>';

    var style = document.createElement('style');
    style.textContent =
      '.lps-geo-suggestion-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;}' +
      '.lps-geo-suggestion-banner{position:relative;z-index:10000;max-width:90%;width:440px;min-height:200px;background:#fff;color:#111;text-align:center;' +
      'border:1px solid rgba(0,0,0,.08);border-radius:12px;padding:2em;box-shadow:0 24px 48px rgba(0,0,0,.25);font-size:15px;line-height:1.5;' +
      'display:flex;flex-direction:column;justify-content:center;align-items:center;}' +
      '.lps-geo-suggestion-banner .geoip-text-block{display:flex;flex-direction:column;align-items:center;padding:0 !important;width:100%;box-sizing:border-box;}' +
      '.lps-geo-suggestion-banner .geoip-message{margin:0 0 1.25em;}' +
      '.lps-geo-suggestion-banner .geoip-button-block{display:flex;gap:10px;flex-wrap:nowrap;justify-content:center;}' +
      '.lps-geo-suggestion-banner button{min-height:44px;padding:0 1.2em;cursor:pointer;font-size:14px;font-weight:500;border-radius:6px;transition:opacity .15s, background .15s, color .15s;border:none;white-space:nowrap;}' +
      '.lps-geo-suggestion-banner button:hover{opacity:.9;}' +
      '.lps-geo-suggestion-banner .lps-geo-switch{background:#111;color:#fff;}' +
      '.lps-geo-suggestion-banner .lps-geo-stay{background:transparent;color:#111;border:1px solid rgba(0,0,0,.3);}' +
      '@media (max-width:380px){.lps-geo-suggestion-banner button{padding:0 .9em;font-size:13px;}}';
    document.head.appendChild(style);

    overlay.appendChild(banner);
    document.body.appendChild(overlay);

    function dismiss() {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }

    banner.querySelector('.lps-geo-switch').addEventListener('click', function () {
      setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      window.location.href = buildRedirectUrl(suggestedRegion);
    });
    banner.querySelector('.lps-geo-stay').addEventListener('click', dismiss);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });
  }

  function run() {
    if (getCookie(COOKIE_NAME)) return;

    var root = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    var url = (typeof location !== 'undefined' ? location.origin : '') + root + 'browsing_context_suggestions.json?country[enabled]=true';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country;
        if (!detected || !detected.handle) return;

        var suggestedRegion = countryToRegion(detected.handle);
        if (!suggestedRegion) return;

        var currentRegion = getCurrentRegion();
        if (suggestedRegion === currentRegion) return;

        showPopup(suggestedRegion, detected.name);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
